



















































































































































































































































































































import {
  computed,
  defineComponent,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';

import CommonTimeline from '@/components/CommonTimeline.vue';
import CommonValueItem from '@/components/CommonValueItem.vue';
import CommonIconTop from '@/components/CommonIconTop.vue';
import CommonChip from '@/components/CommonChip.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';
import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import ViewDeliveryMarkerModal from '@/components/Delivery/ViewDeliveryMarkerModal.vue';
import PanelWithSmallDriverInformation from '@/components/DeliveryNote/PanelWithSmallDriverInformation.vue';
import CommonPanelWithExpandable from '@/components/CommonPanelWithExpandable.vue';
import ViewImageModal from '@/components/ViewImageModal.vue';
import CommonModalWithDivideDelivery from '@/components/DeliveryNote/CommonModalWithDivideDelivery.vue';

import packagesTableOption from '@/table/delivery/package/packagesTable';
import editablePackagesTable from '@/table/delivery/package/editable';
import getDelivery from '@/gql/delivery/getDelivery.gql';
import updateDelivery from '@/gql/delivery/updateDelivery.gql';
import updateDeliveryStatus from '@/gql/delivery/updateDeliveryStatus.gql';
import deleteDeliveryImage from '@/gql/delivery/deleteDeliveryImage.gql';
import updateDeliveryDeliveredStatus from '@/gql/delivery/package/updateDeliveryDeliveredStatus.gql';

import useDelivery from '@/useDelivery';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useDownloadReport from '@/useDownloadReport';
import usePayment from '@/usePayment';
import useAuth from '@/useAuth';

const Information = defineComponent({
  components: {
    CommonTimeline,
    CommonValueItem,
    CommonIconTop,
    CommonChip,
    StickyFooterActionBar,
    CommonModalWithPreset,
    ViewDeliveryMarkerModal,
    PanelWithSmallDriverInformation,
    CommonPanelWithExpandable,
    ViewImageModal,
    CommonModalWithDivideDelivery,
  },
  setup() {
    const { route, router } = useRouter();
    const { getPDFReport } = useDownloadReport();
    const { me } = useAuth();
    const { translate: paymentMethodTranslate } = usePayment();
    const { distanceTypeToChipClass, translateDistanceType } = useDeliveryAreaCode();
    const toDate = (val: any) => useFormat.date(val).displayFullThaiDate();
    const toCurrency = (string: string, min = 0, max = 0) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: min, maximumFractionDigits: max });
    const viewImageModal = ref(null);
    const successUpdateStatusModal = ref(null);
    const delivery: Ref<any> = ref({
      images: [],
      // Q: Why delivery note store as plural ?
      // A: Because we use this field to render in Driver in Delivery Note (PanelWithSmallDriverInformation) component.
      deliveryNotes: [],
    });
    const { result: getDeliveryResult, loading } = useQuery(getDelivery, computed(() => ({
      id: route.value.params.id,
    })), () => ({ fetchPolicy: 'network-only', clientId: 'unauthorize' }));
    const getDeliveryDiscountDetails = computed(() => getDeliveryResult?.value?.delivery);
    const deliveryResult = useResult(getDeliveryResult, { deliveryNotes: [] }, (data) => data.delivery);
    watch(() => deliveryResult.value, (newVal, oldVal) => {
      if (!loading.value && newVal !== oldVal) {
        delivery.value = {
          ...deliveryResult.value,
          deliveryNotes: deliveryResult.value?.deliveryNote ? [deliveryResult.value?.deliveryNote] : [],
          packages: deliveryResult.value?.packages.map((pack: any) => ({
            ...pack,
            allowedEditRemarks: false,
          })),
          deliveryLogs: [
            ...deliveryResult.value?.deliveryLogs,
            { id: -1, status: 'PURCHASE', createdAt: deliveryResult.value.orderDate },
          ],
        };
      }
    });
    const computedAddress = computed(() => {
      if (deliveryResult.value.id) return `${deliveryResult.value.address?.address} ${deliveryResult.value.address.province?.nameInThai} ${deliveryResult.value.address.district ? deliveryResult.value.address.district.nameInThai : ''} ${deliveryResult.value.address.subdistrict ? deliveryResult.value.address.subdistrict.nameInThai : ''} ${deliveryResult.value.address.zipcode}`;
      return '';
    });
    const computedSenderAddress = computed(() => {
      if (deliveryResult.value.senderAddress) return `${deliveryResult.value.senderAddress?.address ?? ''} ${deliveryResult.value.senderAddress.province?.nameInThai ?? ''} ${deliveryResult.value.senderAddress.district?.nameInThai ?? ''} ${deliveryResult.value.senderAddress.subdistrict?.nameInThai ?? ''} ${(deliveryResult.value.senderAddress?.zipcode && deliveryResult.value.senderAddress?.zipcode !== 'null') ? deliveryResult.value.senderAddress?.zipcode : ''}`;
      return '';
    });
    const {
      shipmentStatusClassMap,
      translate: shipmentStatusTranslate,
      english: statusListEng,
    } = useDelivery();

    const enableEditPackage = ref(false);
    const computedPackagesTableOptions = computed(() => {
      if (enableEditPackage.value) return editablePackagesTable;
      return packagesTableOption;
    });
    const computedUpdatePackagesDeliveredInput = computed(() => {
      const result = delivery.value?.packages?.map((pack: any) => ({
        id: pack.id,
        delivered: pack.delivered,
      }));
      return result;
    });
    const updateDeliveryDeliveredStatusMutation = useMutation(updateDeliveryDeliveredStatus, () => ({
      variables: {
        input: {
          id: delivery.value.id,
          packages: computedUpdatePackagesDeliveredInput.value,
        },
      },
      refetchQueries: ['getDelivery', 'getDeliveries', 'getDeliveryNotes'],
    }));
    function toggleEditPackage() {
      enableEditPackage.value = !enableEditPackage.value;
      if (!enableEditPackage.value) {
        updateDeliveryDeliveredStatusMutation.mutate();
      }
    }
    updateDeliveryDeliveredStatusMutation.onDone(() => {
      (successUpdateStatusModal.value as any).compose();
    });

    const reversedDeliveryLog = computed(() => {
      if (!loading.value) {
        if (delivery.value?.deliveryLogs?.length <= 0) return undefined;
        return delivery.value?.deliveryLogs?.sort((deliveryLogs: any, dL: any) => dL.id - deliveryLogs.id);
      }
      return undefined;
    });

    const updateDeliveryItem = ref({
      id: -1,
      status: 'PENDING',
    });
    const updateDeliveryStatusMutation = useMutation(updateDeliveryStatus, () => ({
      variables: {
        id: updateDeliveryItem.value.id,
        input: {
          status: updateDeliveryItem.value.status,
        },
      },
    }));
    function updateDeliveryStatusAction(order: any, status: string) {
      updateDeliveryItem.value = {
        id: order.value.id,
        status,
      };
      updateDeliveryStatusMutation.mutate();
    }
    const confirmUpdateStatusConfirmModal = ref(null);
    const confirmUpdateStatusCancelModal = ref(null);
    const confirmHandler = () => {
      (confirmUpdateStatusConfirmModal.value as any).compose({ action: 'แก้ไข', entity: 'สถานะ' });
    };
    const cancelHandler = () => {
      (confirmUpdateStatusCancelModal.value as any).compose({ action: 'แก้ไข', entity: 'สถานะ' });
    };
    const confirmDone = () => {
      updateDeliveryStatusAction(delivery, 'ACCEPT_SHIPMENT_BY_SHIPPING_PROVIDER');
    };
    const cancelDone = () => {
      updateDeliveryStatusAction(delivery, 'CANCEL');
    };
    updateDeliveryStatusMutation.onDone(() => {
      router.push({ name: 'DeliveryList' });
    });

    const errorUpdateStatusModal = ref(null);
    updateDeliveryStatusMutation.onError(() => {
      (errorUpdateStatusModal.value as any).compose();
    });

    const computedDeliveryArea = computed(() => {
      if (delivery.value.area !== null) return delivery.value.area;
      return { code: 'NA', name: '', distanceType: '' };
    });

    // Show map
    const viewMapModal = ref(null);
    function openMap() { (viewMapModal.value as any).open(); }
    function closeMap() { (viewMapModal.value as any).open(); }
    const mapMarker = computed(() => ([{
      delivery: delivery.value,
      lat: parseFloat(delivery.value.lat) >= -90 && parseFloat(delivery.value.lat) <= 90 ? parseFloat(delivery.value.lat) : 0,
      lng: parseFloat(delivery.value.long) >= -180 && parseFloat(delivery.value.long) <= 180 ? parseFloat(delivery.value.long) : 0,
      open: false,
    }]));

    const deleteImageId = ref(-1);
    const deleteImageModal = ref(null);
    const deleteDeliveryImageMutation = useMutation(deleteDeliveryImage, () => ({
      variables: {
        id: deleteImageId.value,
      },
      refetchQueries: ['getDelivery'],
    }));
    function deleteImageAction(ctx: { id: number }) {
      deleteImageId.value = ctx.id;
      deleteDeliveryImageMutation.mutate();
    }
    deleteDeliveryImageMutation.onDone(() => {
      deleteImageId.value = -1;
    });

    const updatePackageMutation = useMutation(updateDelivery, () => ({
      refetchQueries: ['getDeliveries', 'getDelivery'],
    }));
    function updatePackageAction(id: number, payload: any) {
      updatePackageMutation.mutate({
        input: {
          id: route.value.params.id,
          packages: {
            update: [{
              id,
              ...payload,
            }],
          },
        },
      });
    }

    // Divide Delivery stuff
    const pendingDivideDelivery: Ref<number> = ref(-1);
    const divideDeliveryModal = ref(null);
    function openDivideDeliveryModal($event: number) {
      pendingDivideDelivery.value = $event;
      (divideDeliveryModal.value as any).open();
    }

    function openTracking() {
      window.open(`#/tracking?qs_s=${delivery.value.trackingCode}`, '_blank');
    }

    function openUpdateStatusPage() {
      window.open(`#/android-preview/${delivery.value.trackingCode}`, '_blank');
    }

    return {
      toCurrency,
      computedDeliveryArea,
      distanceTypeToChipClass,
      translateDistanceType,
      paymentMethodTranslate,

      viewImageModal,

      loading,
      showAcceptFooter: (ref(true)),

      statusListEng,
      shipmentStatusClassMap,
      shipmentStatusTranslate,

      confirmHandler,
      cancelHandler,

      delivery,
      computedPackagesTableOptions,
      enableEditPackage,
      toggleEditPackage,
      reversedDeliveryLog,

      toDate,

      computedAddress,
      computedSenderAddress,

      successUpdateStatusModal,
      confirmUpdateStatusConfirmModal,
      confirmUpdateStatusCancelModal,
      errorUpdateStatusModal,
      confirmDone,
      cancelDone,

      getPDFReport,
      me,

      // Use with map
      viewMapModal,
      openMap,
      closeMap,
      mapMarker,

      // Use to delete Image
      deleteImageModal,
      deleteImageAction,

      updatePackageAction,

      getDeliveryDiscountDetails,

      // Use with divide delivery.
      pendingDivideDelivery,
      divideDeliveryModal,
      openDivideDeliveryModal,
      updateDeliveryDeliveredStatusMutation,

      //
      openTracking,
      openUpdateStatusPage,
    };
  },
});

export default Information;
